import React from "react";
import { FaShieldAlt, FaWhatsapp } from "react-icons/fa";
import "./Styles.css";

const Garantia = () => {
  return (
    <section className="garantia-section">
      <div className="garantia-container">
        <div className="garantia-icon">
          <FaShieldAlt />
        </div>
        <div className="garantia-text">
          <h2>Garantia Total</h2>
          <p>Seu pedido protegido e seguro. Qualquer problema, fale conosco!</p>
          <a
            href="https://wa.me/5515996879862?text=Ol%C3%A1!%20Vi%20sua%20landing%20page%20e%20quero%20agendar%20um%20servi%C3%A7o%20de%20manuten%C3%A7%C3%A3o."
            className="btn-whatsapp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp size={20} /> Fale Conosco
          </a>
        </div>
      </div>
    </section>
  );
};

export default Garantia;
